import * as React from "react";

const Ingredient: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40.843" height="54.204" viewBox="0 0 40.843 54.204">
            <g id="ingredient" transform="translate(0.5 0.246)">
                <path
                    id="Path_821"
                    data-name="Path 821"
                    d="M11.15,43.133V10.7"
                    transform="translate(8.771 7.522)"
                    fill="none"
                    stroke="#16402d"
                    stroke-linecap="round"
                    stroke-width="3"
                    fill-rule="evenodd"
                />
                <path
                    id="Path_822"
                    data-name="Path 822"
                    d="M19.921,52.458A18.922,18.922,0,0,0,38.843,33.536q0-10.45-18.921-31.536Q1,23.084,1,33.536A18.922,18.922,0,0,0,19.921,52.458Z"
                    fill="none"
                    stroke="#16402d"
                    stroke-width="3"
                    fill-rule="evenodd"
                />
                <path
                    id="Path_823"
                    data-name="Path 823"
                    d="M25.657,23.577,15.745,34.389h0L5.833,23.577m16.218-9.01-6.307,7.207h0L9.438,14.567"
                    transform="translate(4.177 10.86)"
                    fill="none"
                    stroke="#16402d"
                    stroke-linecap="round"
                    stroke-width="3"
                    fill-rule="evenodd"
                />
            </g>
        </svg>
    );
};

export default React.memo(Ingredient);
